import { PaginationModel } from 'common/src/models';

export const DEFAULT_PAGINATION: PaginationModel = {
  page: 1,
  per_page: 50,
  count: 50
};
